export const StaxPurple = () => (
  <svg
    width="21.909"
    height="20.322201"
    viewBox="0 0 21.909 20.322201"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 0,7.5528 V 9.43533 L 5.273,12.0663 0,14.6973 v 1.8826 l 9.068,-4.5136 z m 0,10.8869 v 1.8825 l 10.954,-5.4434 10.955,5.4434 V 18.4397 L 10.954,12.9963 Z M 10.954,5.44346 0,0 V 1.88253 L 10.954,7.32599 21.909,1.88253 V 0 Z m 10.955,7.34864 v -1.8825 l -5.273,-2.63101 5.273,-2.631 V 3.76506 L 12.841,8.27859 Z M 0,5.64759 21.909,16.5572 V 14.6747 L 0,3.76506 Z"
      fill="#b93be4"
    />
  </svg>
);
export const StaxIcon = () => (
  <svg
    width="21.909"
    height="20.322201"
    viewBox="0 0 21.909 20.322201"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 0,7.5528 V 9.43533 L 5.273,12.0663 0,14.6973 v 1.8826 l 9.068,-4.5136 z m 0,10.8869 v 1.8825 l 10.954,-5.4434 10.955,5.4434 V 18.4397 L 10.954,12.9963 Z M 10.954,5.44346 0,0 V 1.88253 L 10.954,7.32599 21.909,1.88253 V 0 Z m 10.955,7.34864 v -1.8825 l -5.273,-2.63101 5.273,-2.631 V 3.76506 L 12.841,8.27859 Z M 0,5.64759 21.909,16.5572 V 14.6747 L 0,3.76506 Z"
      fill="currentColor"
    />
  </svg>
);
